/* LUMLY · Configura la pista da ballo (impostazione Apple Store) */
(function () {
  'use strict';
  var root = document.querySelector('[data-dfb]');
  if (!root) return;
  var IMG = {}, VARIANT = +root.getAttribute('data-variant') || 0;
  try { IMG = JSON.parse(root.querySelector('[data-dfb-img]').textContent); } catch (e) {}

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var NUM = new Intl.NumberFormat('it-IT', { useGrouping: 'always' });
  var M1 = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- gamma ---------- */
  var SIZES = [['50', '50 × 50 cm', 'Più modulare, per piste piccole e passerelle', 0.5], ['60', '60 × 60 cm', 'Meno giunture, posa più rapida', 0.6]];
  var L = [
    { k: 'mirror', n: 'MirrorFloor', d: 'Effetto specchio 3D Infinity, pannelli magnetici.', tag: 'Specchio 3D', panel: SIZES, power: 'Alimentazione 24V via cavo', ctrl: 'remote', col: [245, 166, 35] },
    { k: 'free', n: 'FreeFloor', d: 'Specchio 3D a batteria: nessun cavo a vista.', tag: 'A batteria', panel: SIZES, power: 'Batteria integrata, 5–12 ore', ctrl: 'remote', battery: 1, col: [255, 236, 205] },
    { k: 'star', n: 'StarFloor', d: 'Micro luci che scintillano: un cielo stellato.', tag: 'Cielo stellato', panel: [['bianca', 'Superficie bianca', 'Luminosa ed elegante, per matrimoni e gala'], ['nera', 'Superficie nera', 'Le stelle risaltano sul nero lucido']], panelH: 'Finitura.', panelS: 'Bianca o nera?', ctrl: 'remote', col: [235, 242, 255], star: 1 },
    { k: 'pixel', n: 'PixelFloor', d: 'Pixel programmabili: animazioni, testi e loghi.', tag: 'Pixel', panel: SIZES, power: 'Alimentazione 24V via cavo', ctrl: 'dmx', col: [120, 90, 240], pix: 1 },
    { k: 'color', n: 'ColorFloor', d: 'Pannelli RGB a colori pieni, a tempo di musica.', tag: 'Colori RGB', panel: null, ctrl: 'dmx', col: [235, 60, 120], rgb: 1 },
    { k: 'glass', n: 'GlassFloor', d: 'Cablata, in vetro temperato, anche per esterni.', tag: 'Vetro temperato', panel: [['in', 'Per interni', 'Club e sale, installazione fissa'], ['out', 'Per esterni', 'Versione impermeabile per terrazze e bordo piscina']], panelH: 'Ambiente.', panelS: 'Dove la installi?', fx: 1, ctrl: 'dmx', col: [245, 166, 35] },
    { k: 'step', n: 'StepFloor', d: 'Pannelli con sensore: si accendono al passo.', tag: 'Sensori di passo', panel: null, ctrl: 'dmx', col: [245, 166, 35], step: 1 },
    { k: 'touch', n: 'TouchFloor', d: 'Pavimento video interattivo per hall e centri commerciali.', tag: 'Video interattivo', panel: null, ctrl: 'sys', fixed: 1, col: [40, 180, 230] }
  ];
  var PRESET = [[3, 3], [4, 4], [5, 5], [6, 6], [8, 6]];

  /* ---------- prezzi indicativi di vendita, IVA esclusa ---------- */
  /* pannello: prezzo per pezzo a scaglioni (<50, 50-99, 100+); m2: prezzo al m² per le piste su progetto */
  var P = {
    mirror: { '50': [45.2, 39.6, 35.0], '60': [59.9, 54.3, 49.7] },
    free: { '50': [84.8, 79.1, 74.6], '60': [92.7, 87.0, 82.5] },
    pixel: { '50': [50.9, 45.2, 40.7], '60': [62.2, 56.5, 52.0] },
    star: { m2: 230 }, color: { m2: 260 }, glass: { m2: 340, out: 390 }, step: { m2: 420 }, touch: { m2: 1250 }
  };
  var RAMP = { '50': { plain: 13.6, cable: 16.4 }, '60': { plain: 14.7, cable: 18.1 } };
  var RAMP_M = { plain: 29, cable: 33, flush: 38 };
  var CASE = { std: 96, charge: 192 }, PER_CASE = { '50': 8, '60': 6 };
  var CTRL = 701, FIX = 571.43;
  var EUR = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, useGrouping: 'always' });
  function tier(n) { return n >= 100 ? 2 : n >= 50 ? 1 : 0; }
  /* calcola il prezzo di una configurazione; o = {line, panel, w, l, ramp, fcase, ctrl} */
  function quote(o) {
    var ln = lineOf(o.line); if (!ln || !o.w || !o.l) return null;
    var pr = P[o.line], area = o.w * o.l, q = { panels: 0, ramp: 0, fcase: 0, ctrl: 0 };
    if (pr.m2) {
      q.panels = area * (o.line === 'glass' && o.panel === 'out' ? pr.out : pr.m2);
      var per = 2 * (o.w + o.l);
      if (RAMP_M[o.ramp]) q.ramp = per * RAMP_M[o.ramp];
      if (CASE[o.fcase]) q.fcase = Math.ceil(area * 4 / 8) * CASE[o.fcase];
      if (ln.ctrl === 'dmx') q.ctrl = CTRL;
    } else {
      var c = o.panel === '50' ? 0.5 : 0.6, nx = Math.round(o.w / c), ny = Math.round(o.l / c), n = nx * ny;
      q.panels = n * pr[o.panel][tier(n)];
      if (RAMP[o.panel][o.ramp]) q.ramp = (2 * (nx + ny) + 4) * RAMP[o.panel][o.ramp];
      if (CASE[o.fcase]) q.fcase = Math.ceil(n / PER_CASE[o.panel]) * CASE[o.fcase];
      if (ln.ctrl === 'dmx' || o.ctrl === 'dmx') q.ctrl = CTRL;
    }
    q.total = Math.round(q.panels + q.ramp + q.fcase + q.ctrl + FIX);
    q.m2 = q.total / area;
    return q;
  }
  /* prezzo "da": pista 6 × 6 m, pannelli 60 cm dove previsti, rampe senza cavo, senza flight case */
  function fromM2(k) {
    var ln = lineOf(k), pn = ln.panel === SIZES ? '60' : ln.panel ? ln.panel[0][0] : 'progetto';
    var q = quote({ line: k, panel: pn, w: 6, l: 6, ramp: ln.fixed ? 'flush' : 'plain', fcase: 'none', ctrl: 'remote' });
    return q ? Math.floor(q.m2 / 10) * 10 : 0;
  }
  function setP(b, d) { var p = b.querySelector('.lwb-opt__p'); if (!p) { p = el('span', 'lwb-opt__p'); b.appendChild(p); } p.textContent = d ? '+ ' + EUR.format(d) : ''; }
  function cur() { return quote({ line: S.line, panel: S.panel, w: S.w, l: S.l, ramp: S.ramp, fcase: S.fcase, ctrl: S.ctrl }); }
  function delta(field, val) {
    var o = { line: S.line, panel: S.panel, w: S.w, l: S.l, ramp: S.ramp, fcase: S.fcase, ctrl: S.ctrl };
    var a = quote(Object.assign({}, o, (function () { var x = {}; x[field] = val; return x; })()));
    var b = quote(Object.assign({}, o, (function () { var x = {}; x[field] = field === 'ctrl' ? 'remote' : 'none'; return x; })()));
    return a && b ? Math.round(a.total - b.total) : 0;
  }
  var MAX = 14, MIN = 1.5;

  var S = { line: null, panel: null, fx: null, size: null, w: 0, l: 0, ramp: null, fcase: null, ctrl: null, slide: 0 };
  function lineOf(k) { for (var i = 0; i < L.length; i++) if (L[i].k === k) return L[i]; return null; }
  function cell() { var ln = lineOf(S.line); if (!ln || !ln.panel || ln.panel !== SIZES) return 0; var p = SIZES.filter(function (x) { return x[0] === S.panel; })[0]; return p ? p[3] : 0; }
  function step() { return cell() || 0.5; }
  function snap(v) { var c = step(); return Math.max(Math.ceil(MIN / c), Math.round(v / c)) * c; }
  function geo() {
    if (!S.line || !S.w || !S.l) return null;
    var c = cell(), g = { w: S.w, l: S.l };
    g.area = S.w * S.l;
    if (c) { g.nx = Math.round(S.w / c); g.ny = Math.round(S.l / c); g.n = g.nx * g.ny; g.ramps = 2 * (g.nx + g.ny); g.c = c; }
    g.ppl = Math.floor(g.area / 0.5);
    return g;
  }
  function panelLabel() {
    var ln = lineOf(S.line); if (!ln) return '';
    if (!ln.panel) return 'Formato definito nel progetto';
    var p = ln.panel.filter(function (x) { return x[0] === S.panel; })[0];
    return p ? p[1] : '';
  }
  function needPanel() { var ln = lineOf(S.line); return !!(ln && ln.panel); }
  function ctrlNeeded() { var ln = lineOf(S.line); return !!(ln && ln.ctrl === 'remote'); }
  function caseOpts() { var ln = lineOf(S.line); if (!ln || ln.fixed) return null; return ln.battery ? [['charge', 'Flight case con ricarica', 'Trasporto, stoccaggio e ricarica dei pannelli'], ['std', 'Flight case standard', 'Trasporto e stoccaggio'], ['none', 'Non serve', 'La pista resta montata']] : [['std', 'Flight case', 'Trasporto e stoccaggio tra un evento e l’altro'], ['none', 'Non serve', 'La pista resta montata']]; }
  function rampOpts() { var ln = lineOf(S.line); if (!ln) return null; if (ln.fixed) return [['flush', 'Profilo di finitura', 'Definito nel progetto, a filo del pavimento'], ['none', 'Non serve', 'La pista è incassata nel pavimento']]; return [['cable', 'Rampe con cavo', 'Il cavo di alimentazione corre nella rampa'], ['plain', 'Rampe senza cavo', 'Solo bordo di accesso'], ['none', 'Non servono', 'La pista è incassata o già bordata']]; }
  function ready() {
    var g = geo(); if (!g) return false;
    if (needPanel() && !S.panel) return false;
    if (S.ramp == null) return false;
    if (caseOpts() && S.fcase == null) return false;
    if (ctrlNeeded() && S.ctrl == null) return false;
    return true;
  }

  /* ---------- opzioni ---------- */
  function opt(attrs, main, sub, right) {
    var b = el('button', 'lwb-opt');
    b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
    for (var k in attrs) b.setAttribute(k, attrs[k]);
    b.innerHTML = '<span class="lwb-opt__m"><b>' + main + '</b>' + (sub ? '<small>' + sub + '</small>' : '') + '</span>' + (right ? '<span class="lwb-opt__p">' + right + '</span>' : '');
    return b;
  }
  function check(container, attr, val) { $$(container + ' [' + attr + ']').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute(attr) === String(val) ? 'true' : 'false'); }); }
  function renderLines() {
    var box = $('[data-dfb-lines]'); box.innerHTML = '';
    L.forEach(function (l) { box.appendChild(opt({ 'data-line': l.k }, 'LUMLY ' + esc(l.n), esc(l.d) + '<br>' + esc(l.tag), 'da ' + NUM.format(fromM2(l.k)) + ' €/m²')); });
  }
  function renderPanel() {
    var ln = lineOf(S.line), box = $('[data-dfb-panel]'); box.innerHTML = '';
    $('[data-dfb-panelh]').innerHTML = (ln && ln.panelH ? ln.panelH : 'Pannello.') + ' <span>' + (ln && ln.panelS ? ln.panelS : 'Scegli il formato.') + '</span>';
    if (!ln) return;
    if (!ln.panel) { box.appendChild(opt({ 'data-panel': 'progetto' }, 'Formato su progetto', 'Pannelli dimensionati sulla tua sala nel preventivo personalizzato', '')); S.panel = 'progetto'; return; }
    ln.panel.forEach(function (p) { box.appendChild(opt({ 'data-panel': p[0] }, esc(p[1]), esc(p[2]), '')); });
  }
  function renderSizes() {
    var box = $('[data-dfb-sizes]'); box.innerHTML = '';
    PRESET.forEach(function (p, i) {
      var w = snap(p[0]), l = snap(p[1]);
      box.appendChild(opt({ 'data-size': String(i), 'data-w': w, 'data-l': l }, M1.format(w) + ' × ' + M1.format(l) + ' m', M1.format(w * l) + ' m² · fino a ' + NUM.format(Math.floor(w * l / 0.5)) + ' persone', ''));
    });
    box.appendChild(opt({ 'data-size': 'custom' }, 'Su misura', 'Imposta larghezza e lunghezza', ''));
  }
  function renderExtras() {
    var r = $('[data-dfb-ramp]'), c = $('[data-dfb-case]'), k = $('[data-dfb-ctrl]'), ln = lineOf(S.line);
    r.innerHTML = ''; c.innerHTML = ''; k.innerHTML = '';
    (rampOpts() || []).forEach(function (o) { r.appendChild(opt({ 'data-ramp': o[0] }, esc(o[1]), esc(o[2]), '')); });
    var co = caseOpts(); $('[data-dfb-caseh]').hidden = !co; c.hidden = !co;
    (co || []).forEach(function (o) { c.appendChild(opt({ 'data-case': o[0] }, esc(o[1]), esc(o[2]), '')); });
    var inc = $('[data-dfb-incl]');
    if (!ln) return;
    if (ln.ctrl === 'remote') {
      inc.innerHTML = '<p class="lwb-incl__t">Telecomando incluso</p><p class="lwb-incl__d">Accendi la pista e cambi effetto dal telecomando, senza regia.</p>';
      k.hidden = false; $('[data-dfb-ctrlh]').hidden = false;
      k.appendChild(opt({ 'data-ctrl': 'remote' }, 'Solo telecomando', 'Per feste ed eventi senza regia luci', 'Incluso'));
      k.appendChild(opt({ 'data-ctrl': 'dmx' }, 'Aggiungi il controller DMX512', 'Per collegare la pista alla regia luci', ''));
    } else {
      inc.innerHTML = ln.ctrl === 'sys' ? '<p class="lwb-incl__t">Sistema di controllo incluso</p><p class="lwb-incl__d">Contenuti interattivi e controllo definiti nel progetto.</p>' : '<p class="lwb-incl__t">Controller incluso</p><p class="lwb-incl__d">Controller della pista con programmi integrati e ingresso DMX512 per la regia.</p>';
      k.hidden = true; $('[data-dfb-ctrlh]').hidden = true;
    }
  }

  /* ---------- galleria ---------- */
  var slides = [];
  function buildGallery() {
    var k = S.line || 'mirror', imgs = IMG[k] || [];
    var track = $('[data-dfb-track]');
    if (track.getAttribute('data-k') !== k) {
      track.setAttribute('data-k', k); track.innerHTML = '';
      imgs.forEach(function (src, i) { var im = el('img'); im.src = src; im.alt = 'LUMLY ' + (lineOf(k) ? lineOf(k).n : 'Dancefloor') + ', immagine ' + (i + 1); im.loading = i ? 'lazy' : 'eager'; im.decoding = 'async'; track.appendChild(im); });
    }
    slides = imgs.map(function (_, i) { return { t: 'img', i: i }; });
    if (geo()) slides.push({ t: 'scale' });
    if (S.slide >= slides.length) S.slide = 0;
    var dots = $('[data-dfb-dots]'); dots.innerHTML = '';
    slides.forEach(function (sl, i) {
      var b = el('button'); b.type = 'button';
      if (sl.t === 'scale') { b.textContent = 'Vista dall’alto'; b.setAttribute('aria-label', 'Pista vista dall’alto'); }
      else { b.className = 'is-dot'; b.setAttribute('aria-label', 'Immagine ' + (i + 1)); }
      b.addEventListener('click', function () { show(i); });
      dots.appendChild(b);
    });
    root.querySelector('.lwb-gal__nav').style.display = slides.length > 1 ? '' : 'none';
    show(S.slide);
  }
  function show(i) {
    if (!slides.length) return;
    S.slide = (i + slides.length) % slides.length;
    var sl = slides[S.slide], sc = $('[data-dfb-scale]');
    $$('[data-dfb-track] img').forEach(function (im, j) { im.classList.toggle('is-on', sl.t === 'img' && sl.i === j); });
    sc.hidden = sl.t !== 'scale';
    if (sl.t === 'scale') drawScale();
    $$('[data-dfb-dots] button').forEach(function (b, j) { b.setAttribute('aria-current', j === S.slide ? 'true' : 'false'); });
    $('[data-dfb-cap]').textContent = sl.t === 'scale' ? 'Proporzioni reali: ogni sagoma è una persona che balla, circa 0,5 m².' : 'Immagini illustrative.';
  }
  function hashN(a, b) { var s = Math.sin(a * 127.1 + b * 311.7) * 43758.5453; return s - Math.floor(s); }
  function drawScale() {
    var g = geo(); if (!g) return;
    var ln = lineOf(S.line), c = g.c || 0.5, nx = Math.round(g.w / c), ny = Math.round(g.l / c), col = ln.col;
    var pad = 0.9, fs = Math.max(g.w, g.l) * 0.035 + 0.08;
    var s = '<svg viewBox="' + [-pad, -pad, g.w + pad * 2, g.l + pad * 2].join(' ') + '" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Pista di ' + M1.format(g.w) + ' per ' + M1.format(g.l) + ' metri vista dall’alto">';
    if (S.ramp && S.ramp !== 'none') s += '<rect x="-.12" y="-.12" width="' + (g.w + .24) + '" height="' + (g.l + .24) + '" rx=".06" fill="#2a2a2c"/>';
    for (var j = 0; j < ny; j++) for (var i = 0; i < nx; i++) {
      var x = i * c, y = j * c, gp = c * 0.04, sz = c - gp * 2, cc = col;
      if (ln.rgb) { var pal = [[245, 166, 35], [235, 60, 120], [40, 200, 230], [140, 80, 240]]; cc = pal[(i + j) % 4]; }
      if (ln.pix) { var h = (i * 18 + j * 11) % 360; cc = 'hsl(' + h + ',70%,45%)'; }
      var fill = typeof cc === 'string' ? cc : 'rgb(' + cc.join(',') + ')';
      if (ln.star) { s += '<rect x="' + (x + gp) + '" y="' + (y + gp) + '" width="' + sz + '" height="' + sz + '" fill="' + (S.panel === 'bianca' ? '#d9d9de' : '#0d0d10') + '"/>'; for (var q = 0; q < 4; q++) s += '<circle cx="' + (x + gp + hashN(i * 3 + q, j) * sz) + '" cy="' + (y + gp + hashN(j * 5 + q, i) * sz) + '" r="' + c * 0.025 + '" fill="' + (S.panel === 'bianca' ? '#fff8e6' : '#f2f5ff') + '"/>'; continue; }
      if (ln.rgb || ln.pix) { s += '<rect x="' + (x + gp) + '" y="' + (y + gp) + '" width="' + sz + '" height="' + sz + '" fill="' + fill + '" opacity=".85"/>'; continue; }
      if (ln.step) { s += '<rect x="' + (x + gp) + '" y="' + (y + gp) + '" width="' + sz + '" height="' + sz + '" fill="' + (hashN(i, j) > 0.86 ? fill : '#151517') + '"/>'; continue; }
      if (ln.k === 'touch') { s += '<rect x="' + (x + gp) + '" y="' + (y + gp) + '" width="' + sz + '" height="' + sz + '" fill="rgb(' + Math.round(10 + 30 * hashN(i, j)) + ',' + Math.round(60 + 60 * hashN(j, i)) + ',' + Math.round(90 + 60 * hashN(i + j, 3)) + ')"/>'; continue; }
      s += '<rect x="' + (x + gp) + '" y="' + (y + gp) + '" width="' + sz + '" height="' + sz + '" fill="#0b0b0d"/>';
      for (var r = 0; r < 3; r++) { var k = 1 - r / 3, hs = sz / 2 * (0.2 + 0.8 * k); s += '<rect x="' + (x + c / 2 - hs) + '" y="' + (y + c / 2 - hs) + '" width="' + hs * 2 + '" height="' + hs * 2 + '" fill="none" stroke="' + fill + '" stroke-opacity="' + (0.25 + 0.6 * k * k) + '" stroke-width="' + c * 0.025 + '"/>'; }
    }
    // persone in scala (vista dall'alto): una sagoma ogni ~2,5 m², al massimo 40
    var np = Math.min(40, Math.max(2, Math.round(g.area / 2.5)));
    for (var p = 0; p < np; p++) {
      var px = 0.3 + hashN(p, 7) * (g.w - 0.6), py = 0.3 + hashN(9, p) * (g.l - 0.6);
      s += '<g opacity=".9"><ellipse cx="' + px + '" cy="' + py + '" rx=".24" ry=".15" fill="rgba(0,0,0,.55)"/><circle cx="' + px + '" cy="' + py + '" r=".1" fill="rgba(245,245,247,.85)"/></g>';
    }
    var tx = 'font-family="Inter,-apple-system,sans-serif" font-size="' + fs + '" fill="rgba(245,245,247,.75)"';
    s += '<text x="' + (g.w / 2) + '" y="' + (-pad / 2.2) + '" text-anchor="middle" ' + tx + '>' + M1.format(g.w) + ' m</text>';
    s += '<text x="' + (-pad / 2.2) + '" y="' + (g.l / 2) + '" text-anchor="middle" ' + tx + ' transform="rotate(-90 ' + (-pad / 2.2) + ' ' + (g.l / 2) + ')" dominant-baseline="middle">' + M1.format(g.l) + ' m</text>';
    s += '</svg>';
    $('[data-dfb-scale]').innerHTML = s;
  }

  /* ---------- stato ---------- */
  function open(step, on) { var s = $('[data-step="' + step + '"]'); if (s) s.classList.toggle('is-open', !!on); }
  function rows() {
    var ln = lineOf(S.line), g = geo(); if (!ln || !g) return [];
    var r = [['Pista', 'LUMLY ' + ln.n]];
    r.push([ln.panelH ? ln.panelH.replace('.', '') : 'Pannello', panelLabel()]);
    r.push(['Dimensioni', M1.format(g.w) + ' × ' + M1.format(g.l) + ' m']);
    r.push(['Superficie', M1.format(g.area) + ' m²']);
    r.push(['Pannelli', g.n ? NUM.format(g.n) + ' (' + g.nx + ' × ' + g.ny + ')' : 'Definiti nel progetto']);
    var ro = (rampOpts() || []).filter(function (o) { return o[0] === S.ramp; })[0];
    if (ro) r.push(['Bordo', ro[1] + (g.ramps && (S.ramp === 'cable' || S.ramp === 'plain') ? ' · ' + g.ramps + ' + 4 angolari' : '')]);
    var co = (caseOpts() || []).filter(function (o) { return o[0] === S.fcase; })[0];
    if (co) r.push(['Flight case', co[0] === 'none' ? 'No' : co[1]]);
    r.push(['Controllo', ln.ctrl === 'remote' ? (S.ctrl === 'dmx' ? 'Telecomando e controller DMX512' : 'Telecomando') : ln.ctrl === 'sys' ? 'Sistema interattivo incluso' : 'Controller incluso (DMX512)']);
    return r;
  }
  function boxList() {
    var ln = lineOf(S.line), g = geo(); if (!ln || !g) return [];
    var b = [];
    b.push((g.n ? NUM.format(g.n) + ' pannelli ' + panelLabel() : 'Pannelli LUMLY ' + ln.n + ' per ' + M1.format(g.area) + ' m²') + (ln.k === 'star' ? ', superficie ' + S.panel : ''));
    b.push(ln.battery ? 'Batterie integrate nei pannelli' : 'Alimentatori 24V e cavi di collegamento');
    if (S.ramp === 'cable' || S.ramp === 'plain') b.push('Rampe perimetrali ' + (S.ramp === 'cable' ? 'con cavo' : 'senza cavo') + (g.ramps ? ' (' + g.ramps + ' + 4 angolari)' : ''));
    if (S.ramp === 'flush') b.push('Profilo di finitura perimetrale');
    if (S.fcase === 'charge') b.push('Flight case con ricarica integrata');
    if (S.fcase === 'std') b.push('Flight case per trasporto e stoccaggio');
    if (ln.ctrl === 'remote') { b.push('Telecomando'); if (S.ctrl === 'dmx') b.push('Controller DMX512 della pista'); }
    else if (ln.ctrl === 'sys') b.push('Sistema di controllo e contenuti interattivi');
    else b.push('Controller della pista con programmi integrati');
    b.push('Schema di montaggio, istruzioni e schede tecniche');
    return b;
  }
  function update() {
    check('[data-dfb-lines]', 'data-line', S.line);
    check('[data-dfb-panel]', 'data-panel', S.panel);
    check('[data-dfb-sizes]', 'data-size', S.size);
    check('[data-dfb-ramp]', 'data-ramp', S.ramp);
    check('[data-dfb-case]', 'data-case', S.fcase);
    check('[data-dfb-ctrl]', 'data-ctrl', S.ctrl);
    var ln = lineOf(S.line), g = geo(), pOk = !needPanel() || !!S.panel;
    open('panel', !!ln); open('size', !!(ln && pOk)); open('acc', !!(ln && pOk && g)); open('sum', ready());
    $('[data-dfb-custom]').hidden = S.size !== 'custom';
    if (g) {
      $('[data-dfb-wv]').textContent = M1.format(g.w) + ' m'; $('[data-dfb-lv]').textContent = M1.format(g.l) + ' m';
      var rd = [['Superficie', M1.format(g.area) + ' m²'], ['Pannelli', g.n ? NUM.format(g.n) : 'Su progetto'], ['Persone in pista', 'fino a ' + NUM.format(g.ppl)]];
      $('[data-dfb-read]').innerHTML = rd.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>'; }).join('');
    } else $('[data-dfb-read]').innerHTML = '';
    $('[data-dfb-sizep]').textContent = cell() ? 'Le misure seguono i pannelli da ' + Math.round(cell() * 100) + ' cm.' : 'Misure indicative: il formato dei pannelli è definito nel progetto.';
    var R = rows(), ok = ready();
    if (ln && g) {
      $('[data-dfb-sumn]').textContent = 'LUMLY ' + ln.n;
      $('[data-dfb-sum]').innerHTML = R.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
      $('[data-dfb-box]').innerHTML = boxList().map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
      var qq = cur(), body = R.map(function (r) { return r[0] + ': ' + r[1]; }).join('\n') + (qq && ok ? '\nPrezzo indicativo: ' + EUR.format(qq.total) + ' IVA esclusa' : '');
      $('[data-dfb-mail]').href = 'mailto:info@lumly.it?subject=' + encodeURIComponent('Preventivo personalizzato LUMLY ' + ln.n) + '&body=' + encodeURIComponent('Buongiorno,\nvorrei un preventivo personalizzato per questa pista:\n\n' + body + '\n\nData e luogo dell\'evento:\n');
    }
    if (ln && g) {
      $$('[data-dfb-ramp] [data-ramp]').forEach(function (b) { var v = b.getAttribute('data-ramp'); setP(b, v === 'none' ? 0 : delta('ramp', v)); });
      $$('[data-dfb-case] [data-case]').forEach(function (b) { var v = b.getAttribute('data-case'); setP(b, v === 'none' ? 0 : delta('fcase', v)); });
      $$('[data-dfb-ctrl] [data-ctrl="dmx"]').forEach(function (b) { setP(b, CTRL); });
    }
    var q = (ln && g) ? cur() : null, pf = $('[data-dfb-price]'), pn = $('[data-dfb-pricen]'), bp = $('[data-dfb-barp]'), bpn = $('[data-dfb-barpn]');
    if (q && ok) {
      pf.textContent = EUR.format(q.total); pn.textContent = 'Prezzo indicativo, IVA esclusa · circa ' + NUM.format(Math.round(q.m2)) + ' €/m². Prezzo definitivo nel preventivo personalizzato.';
      bp.textContent = EUR.format(q.total); bpn.textContent = 'IVA esclusa';
    } else if (q) {
      pf.textContent = 'da ' + EUR.format(q.total); pn.textContent = 'Completa gli accessori per il prezzo indicativo, IVA esclusa.';
      bp.textContent = 'da ' + EUR.format(q.total); bpn.textContent = 'IVA esclusa';
    } else if (ln) {
      pf.textContent = 'da ' + NUM.format(fromM2(ln.k)) + ' €/m²'; pn.textContent = 'IVA esclusa'; bp.textContent = 'da ' + NUM.format(fromM2(ln.k)) + ' €/m²'; bpn.textContent = 'IVA esclusa';
    }
    var fr = $('[data-dfb-from]'); if (fr) fr.textContent = ln ? 'LUMLY ' + ln.n + ' da ' + NUM.format(fromM2(ln.k)) + ' €/m², IVA esclusa.' : 'Da ' + NUM.format(Math.min.apply(null, L.map(function (l) { return fromM2(l.k); }))) + ' €/m², IVA esclusa.';
    $('[data-dfb-order]').disabled = !ok;
    if (ln) {
      $('[data-dfb-barn]').textContent = 'LUMLY ' + ln.n;
      $('[data-dfb-bars]').textContent = g ? M1.format(g.w) + ' × ' + M1.format(g.l) + ' m' + (g.n ? ' · ' + g.n + ' pannelli' : '') : 'Scegli le dimensioni';
      $('[data-dfb-barbtn]').textContent = ok ? 'Invia l’ordine' : 'Continua';
    }
    barState(); buildGallery(); saveHash();
  }

  /* ---------- barra inferiore ---------- */
  var ctaVisible = false, inSection = false;
  function barState() {
    var bar = $('[data-dfb-bar]'), on = !!S.line && inSection && !ctaVisible;
    bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    $('[data-dfb-barbtn]').tabIndex = on ? 0 : -1;
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { ctaVisible = e[0].isIntersecting; barState(); }).observe($('[data-dfb-order]'));
    new IntersectionObserver(function (e) { inSection = e[0].isIntersecting; barState(); }, { rootMargin: '0px 0px -40% 0px' }).observe(root.querySelector('.lwb-grid'));
  } else inSection = true;
  function hdr() { return (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--lw-hdr')) || 92) + 24; }
  function goStep(name) { var t = $('[data-step="' + name + '"]'); if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - hdr(), behavior: 'smooth' }); }
  function nextStep() {
    var need = !S.line ? 'line' : (needPanel() && !S.panel) ? 'panel' : !geo() ? 'size' : !ready() ? 'acc' : 'sum';
    goStep(need); return need;
  }

  /* ---------- eventi ---------- */
  function setLine(k) {
    if (S.line === k) return;
    S.line = k; S.panel = null; S.ramp = null; S.fcase = null; S.ctrl = null; S.slide = 0;
    var ln = lineOf(k);
    if (ln.panel === SIZES) S.panel = '60';
    renderPanel(); renderSizes(); renderExtras();
    if (S.w && S.l) { S.w = snap(S.w); S.l = snap(S.l); } else { S.size = '1'; S.w = snap(4); S.l = snap(4); }
    if (ln.fixed) { S.fcase = null; }
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-line')) { setLine(b.getAttribute('data-line')); update(); return; }
    if (b.hasAttribute('data-panel')) {
      S.panel = b.getAttribute('data-panel');
      if (S.w) { S.w = snap(S.w); S.l = snap(S.l); }
      renderSizes(); update(); return;
    }
    if (b.hasAttribute('data-size')) {
      S.size = b.getAttribute('data-size');
      if (b.hasAttribute('data-w')) { S.w = +b.getAttribute('data-w'); S.l = +b.getAttribute('data-l'); }
      update(); return;
    }
    if (b.hasAttribute('data-inc') || b.hasAttribute('data-dec')) {
      var ax = b.getAttribute('data-inc') || b.getAttribute('data-dec'), d = (b.hasAttribute('data-inc') ? 1 : -1) * step();
      if (ax === 'w') S.w = Math.max(snap(MIN), Math.min(MAX, +(S.w + d).toFixed(2))); else S.l = Math.max(snap(MIN), Math.min(MAX, +(S.l + d).toFixed(2)));
      S.size = 'custom'; update(); return;
    }
    if (b.hasAttribute('data-ramp')) { S.ramp = b.getAttribute('data-ramp'); update(); return; }
    if (b.hasAttribute('data-case')) { S.fcase = b.getAttribute('data-case'); update(); return; }
    if (b.hasAttribute('data-ctrl')) { S.ctrl = b.getAttribute('data-ctrl'); update(); return; }
    if (b.hasAttribute('data-dfb-prev')) { show(S.slide - 1); return; }
    if (b.hasAttribute('data-dfb-next')) { show(S.slide + 1); return; }
    if (b.hasAttribute('data-dfb-barbtn')) { if (nextStep() === 'sum' && ready()) order(); return; }
    if (b.hasAttribute('data-dfb-order')) { order(); return; }
  });
  root.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('[role="radio"]'); if (!b) return;
    if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) < 0) return;
    var g = Array.prototype.slice.call(b.closest('[role="radiogroup"]').querySelectorAll('[role="radio"]'));
    var i = g.indexOf(b) + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1);
    var n = g[(i + g.length) % g.length]; n.focus(); n.click(); e.preventDefault();
  });

  /* ---------- ordine ---------- */
  function order() {
    var btn = $('[data-dfb-order]'), err = $('[data-dfb-err]');
    if (!ready() || !VARIANT) return;
    err.hidden = true; btn.classList.add('is-busy'); btn.disabled = true; btn.textContent = 'Invio in corso…';
    var props = {};
    rows().forEach(function (r) { props[r[0]] = r[1]; });
    var q = cur(); props['Prezzo indicativo'] = q ? EUR.format(q.total) + ' IVA esclusa' : 'Nel preventivo personalizzato';
    props['Prezzo definitivo'] = 'Nel preventivo personalizzato firmato';
    var co = $('[data-dfb-co]').value.trim(), ev = $('[data-dfb-ev]').value.trim(), nt = $('[data-dfb-note]').value.trim();
    if (co) props['Azienda o ente'] = co;
    if (ev) props['Data e luogo dell’evento'] = ev;
    if (nt) props['Note'] = nt;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: VARIANT, quantity: 1, properties: props }] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { window.location.href = base + 'checkout'; })
      .catch(function () {
        btn.classList.remove('is-busy'); btn.disabled = false; btn.textContent = 'Invia l’ordine';
        err.textContent = 'Non siamo riusciti a inviare l’ordine. Riprova oppure scrivici a info@lumly.it.'; err.hidden = false;
      });
  }

  /* ---------- link diretti: #configura-mirror, #configura-free ... ---------- */
  var writing = false;
  function saveHash() {
    if (!S.line) return;
    var q = 'configura-' + S.line;
    if (('#' + q) === location.hash) return;
    writing = true; try { history.replaceState(null, '', '#' + q); } catch (e) {} writing = false;
  }
  function loadHash(scroll) {
    var m = (location.hash || '').match(/^#configura-([a-z]+)/);
    if (m && lineOf(m[1])) { setLine(m[1]); update(); if (scroll) setTimeout(function () { goStep('line'); }, 60); return true; }
    return false;
  }
  window.addEventListener('hashchange', function () { if (!writing) loadHash(true); });

  renderLines(); renderPanel(); renderSizes(); renderExtras();
  if (!loadHash(true)) update();
})();
